export const iconFontAwesomeEditingWandMagic = (
	<i className="fa-solid fa-wand-magic"></i>
);
